import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  searchBar: {
    width: '100%',
    marginRight: "2.825rem",
    marginTop: "1rem",
  },
  wrapper: {
    display: "flex",
    width: "100%",
    minHeight: "calc(100vh - 17rem)",
    flexDirection: "column",
  },
  subtitle: {
    fontWeight: 500,
    marginBottom: "1.75rem",
  },
  section: {
    marginBottom: "1.25rem",
    width: "80%",
    alignSelf: "center",
  },
  input: {
    width: "100%",
  },
  waveBottom: {
    width: "100%",
    "& > img": {
      display: "block",
      width: "100%",
      height: "6rem",
      marginBottom: "3rem"
    },
  },
  button: {
    alignSelf: "center",
    width: "20rem",
    maxWidth: "240px",
    marginTop: "1rem",
  },
}) 